import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useUser } from "@/contexts/UserContext";
import { ROUTES } from "@/config/routeConfig";
import { CustomerDetailsTab } from '@/shared/config/customer-details-tabs';
import { useRouteNavigation } from "@/shared/hooks/use-route-navigation";
import { AccountDetailsTab } from "@/shared/config/account-details-tabs";
import { useUserRoles } from "@/shared/hooks/userRoles";
import { organizationToCustomer } from "@/shared/types/userTypes";

const Index = () => {
  const navigate = useNavigate();
  const {
    currentUser,
    isLoading,
    isInitialized,
    selectedRegionCode,
    selectedOrganization,
  } = useUser();
  const { isPlatformUser, isCustomerUser, isTenantUser } = useUserRoles();
  const { navigateToAccountDetails, navigateToCustomerDetails } = useRouteNavigation();

  useEffect(() => {
    // Only redirect once loading is complete and context is initialized
    if (!isLoading && isInitialized) {
      if (isPlatformUser && selectedRegionCode) {
        navigate(ROUTES.ACCOUNTS, { replace: true });
      } else if (isCustomerUser && selectedOrganization) {
        const organization =
          currentUser?.organizations?.find(
            (entry) => entry.organizationId === selectedOrganization.organizationId,
          )
          ?? selectedOrganization;
        const customer = organizationToCustomer(organization);
        navigateToCustomerDetails(customer, CustomerDetailsTab.DASHBOARD, true);
      } else if (isTenantUser && selectedOrganization) {
        navigateToAccountDetails({
          organization: selectedOrganization,
          accountDetailsTab: AccountDetailsTab.DASHBOARD,
          replace: true,
        });
      } else if (!currentUser) {
        navigate(ROUTES.LOGIN, { replace: true });
      }
    }
  }, [
    currentUser,
    isLoading,
    isInitialized,
    isPlatformUser,
    isCustomerUser,
    isTenantUser,
    selectedRegionCode,
    selectedOrganization,
    navigate,
    navigateToCustomerDetails,
    navigateToAccountDetails,
  ]);

  // Show loading spinner while checking authentication or if context is not initialized
  if (isLoading || !isInitialized) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="flex flex-col items-center space-y-4">
          <Loader2 className="h-8 w-8 animate-spin text-primary" />
          <p>
            {!isInitialized ? 'Initializing...' : 'Loading...'}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <Loader2 className="h-8 w-8 animate-spin text-primary" />
    </div>
  );
};

export default Index;
